export enum B2cShipmentStatus {
  none = '',
  Created = 'Created',
  AssignFleet = 'FLEET_ASSIGNED',
  DriverAssigned = 'Driver Assigned',
  OutForPickup = 'Out for pickup',
  OrderPickedUp = 'Order picked up',
  OutForDelivery = 'Out for Delivery (OFD)',
  Delivered = 'Delivered',
  NotDelivered = 'Not delivered',
  Lost = 'Lost',
  Damaged = 'Damaged',
  ScheduleDelivery = 'Schedule Delivery',
  Canceled = 'Canceled',
  ArrivedAtPickupLocation = 'Arrived at pickup location',
  ArrivedAtPharmacy = 'Arrived at pharmacy',
  ReturnToOrigin = 'Return to Origin (RTO)',
  PickedByConsumer = 'PICKED_BY_CONSUMER',
  ShipmentIntegrationCanceled = 'SHIPMENT_INTEGRATION_CANCELED',
  NotPickedUp = 'Not picked up',
}
